import Messages from 'components/Messages/Messages';
import NotFound from 'components/NotFound/NotFound';
import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Landing from './Landing/Landing';

type Props = {
  authenticated: boolean
}

const Routes : React.FC<Props> = ({ authenticated }) => {

  return (
      <BrowserRouter>
          <Switch>
            <Route path="/" exact component={Landing} />
            <Route path="/messages/:name" exact component={Messages} />
            <Route path="/messages/:name/:query" exact component={Messages} />
            <Route path="*" exact component={NotFound} />
          </Switch>
      </BrowserRouter>
  );

}

export default Routes;